export enum VoteTypeEnum { 
    YesNoSuper = 1,
    FiveStars = 2
}